import msm_api from "./msm-api.json";
import axios from "axios";

// Il browser parla solo con questi percorsi same-origin: le edge function Netlify
// (netlify/edge-functions/msm-api-proxy.js e chat-proxy.js) aggiungono la Basic Auth
// lato server. Nessuna credenziale deve stare nel bundle: mai variabili GATSBY_ per i segreti.
export const MSM_API_BASE = "/api/msm";
export const MSM_CHAT_BASE = "/api/chat-proxy";

export const MSMRequest = async (
  name,
  payload = {},
  returnResposne = false
) => {
  const endpoint = msm_api.endpoint?.[name] || null;
  if (!endpoint) {
    return null;
  }
  const abortController = new AbortController();
  try {
    const response = await axios(
      {
        url: `${MSM_API_BASE}${endpoint.url}`,
        method: endpoint.method,
        data: payload,
        headers: msm_api.headers,
      },
      { signal: abortController.signal }
    );
    pushDatalayerEventIfExistInResponse(response);

    if (returnResposne) {
      return response;
    } else if (response.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const MSMChatRequest = async (name, payload = {}) => {
  const endpoint = msm_api.endpoint?.[name] || null;
  if (!endpoint) {
    return null;
  }
  const abortController = new AbortController();
  try {
    const response = await axios(
      {
        url: `${MSM_CHAT_BASE}${endpoint.url}`,
        method: endpoint.method,
        data: payload,
        headers: msm_api.headers,
      },
      { signal: abortController.signal }
    );
    pushDatalayerEventIfExistInResponse(response);
    return response.data;
  } catch (error) {
    return null;
  }
};

function pushDatalayerEventIfExistInResponse(response) {
  if (
    typeof window !== "undefined" &&
    window.dataLayer &&
    window.dataLayer.push &&
    (response.data?.dataLayerGa4 || response.data?.dataLayerGtm)
  ) {
    if (response.data?.dataLayerGa4) {
      window.dataLayer.push(response.data.dataLayerGa4);
    }
    if (response.data?.dataLayerGtm) {
      window.dataLayer.push(response.data.dataLayerGtm);
    }
  }
}
